import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController, AlertController } from '@ionic/angular';

@Component({
  selector: 'app-program-details',
  templateUrl: './program-details.component.html',
  styleUrls: ['./program-details.component.scss'],
})
export class ProgramDetailsComponent implements OnInit {
  programTitle: string;
  programAuthor: string;
  programDescription: string;
  storeUrl: string;

  constructor(
    private navParams: NavParams,
    private popoverController: PopoverController
  ) { }

  ngOnInit() {
    this.programTitle = this.navParams.data.title;
    this.programAuthor = this.navParams.data.author;
    this.programDescription = this.navParams.data.description;
    this.storeUrl = this.navParams.data.storeUrl;
  }

}
